<select class="form-control width50" aria-label="Select agency" title="Agency Name" [(ngModel)]="agencyList" (ngModelChange)="changeAgency($event)" name="AgencyNameList">
	<option role="option" value='' selected>-Select Agency-</option>
	<option role="option" *ngFor="let a of agencyList" [value]="a.agencyCode">{{a.agencyCode - a.agencyBureauName}}</option>
</select>